import { __assign, __decorate, __extends } from "tslib";
import { is8pxTheme } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import warning from 'warning';
import { stopPropagation } from '@skbkontur/react-ui/lib/events/stopPropagation';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { CloudIcon } from '../../internal/CloudIcon';
import { ArrowChevronDownIcon as ArrowChevronDown } from '@skbkontur/react-ui/internal/icons/16px';
import { isIE11 } from '@skbkontur/react-ui/lib/client';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './Logotype.styles';
import { ProductWidget } from './ProductWidget';
import { LogotypeLocaleHelper } from './locale';
var INITIAL_WIDTH = 25;
var INITIAL_HEIGHT = 18;
var INITIAL_VERTICAL_ALIGN = -1;
var INITIAL_FONT_SIZE = 22;
var DEFAULT_LOGO_SIZE = 24;
var DEFAULT_LOGO_SIZE_OLD = INITIAL_FONT_SIZE;

var Logotype =
/** @class */
function (_super) {
  __extends(Logotype, _super);

  function Logotype() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.logoWrapper = null;
    _this.isWidgetInited = false;

    _this.getSize = function () {
      var _a;

      return _a = _this.props.size, _a !== null && _a !== void 0 ? _a : _this.isOldBehavior ? DEFAULT_LOGO_SIZE_OLD : DEFAULT_LOGO_SIZE;
    };

    _this.renderLogo = function () {
      var _a = _this.props,
          konturLogo = _a.konturLogo,
          productLogo = _a.productLogo;

      var size = _this.getSize();

      return React.createElement(React.Fragment, null, React.createElement("span", {
        className: jsStyles.konturLogo()
      }, konturLogo && React.cloneElement(konturLogo, {
        size: size
      })), productLogo && React.createElement("span", {
        className: jsStyles.productLogo()
      }, React.cloneElement(productLogo, {
        size: size
      })));
    };

    _this.renderLogoOld = function () {
      var _a = _this.props,
          suffix = _a.suffix,
          _b = _a.locale,
          propLocale = _b === void 0 ? _this.locale : _b,
          color = _a.color,
          textColor = _a.textColor;

      var size = _this.getSize();

      var cloudStyle = {
        color: color,
        width: size * (INITIAL_WIDTH / INITIAL_FONT_SIZE),
        height: size * (INITIAL_HEIGHT / INITIAL_FONT_SIZE),
        verticalAlign: size * (INITIAL_VERTICAL_ALIGN / INITIAL_FONT_SIZE)
      };
      return React.createElement(React.Fragment, null, React.createElement("span", {
        style: {
          color: textColor
        }
      }, propLocale.prefix), React.createElement("span", {
        className: jsStyles.cloud(),
        style: cloudStyle
      }, React.createElement(CloudIcon, null)), React.createElement("span", {
        style: {
          color: textColor
        }
      }, propLocale.suffix, suffix && '.'), suffix && React.createElement("span", {
        style: {
          color: color
        }
      }, suffix));
    };

    _this.refLogoWrapper = function (el) {
      if (_this.logoWrapper) {
        _this.logoWrapper.removeEventListener('click', _this.handleNativeLogoClick);
      }

      if (el) {
        el.addEventListener('click', _this.handleNativeLogoClick);
      }

      _this.logoWrapper = el;
    };

    _this.handleNativeLogoClick = function (event) {
      stopPropagation(event);
    };

    _this.initWidget = function () {
      if (!_this.isWidgetInited) {
        ProductWidget.init();
        _this.isWidgetInited = true;
      }
    };

    return _this;
  }

  Logotype.prototype.componentDidMount = function () {
    if (this.props.withWidget) {
      this.initWidget();
    }

    warning(!this.props.locale, 'locale props is deprecated, use LocaleContext instead');
  };

  Logotype.prototype.componentDidUpdate = function () {
    if (this.props.withWidget) {
      this.initWidget();
    }
  };

  Logotype.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return _this.renderMain();
    });
  };

  Logotype.prototype.renderMain = function () {
    var _a, _b, _c;

    var _d = this.props,
        Component = _d.component,
        href = _d.href,
        withWidget = _d.withWidget,
        onArrowClick = _d.onArrowClick;
    var size = this.getSize();
    var isOldBehavior = this.isOldBehavior;
    var componentClassName = cn(jsStyles.root(), isOldBehavior && jsStyles.rootOld(this.theme));
    var dividerClassName = cn(!isOldBehavior && jsStyles.divider(this.theme), isOldBehavior && jsStyles.dividerOld(this.theme));
    var dividerStyle = !isOldBehavior && !is8pxTheme(this.theme) ? {
      height: '100%'
    } : {};
    var buttonClassName = cn((_a = {}, _a[jsStyles.button(this.theme)] = !isOldBehavior, _a[jsStyles.buttonIE11Fallback()] = !isOldBehavior && isIE11, _a[jsStyles.buttonOld(this.theme)] = isOldBehavior, _a));
    var styleComponent = isOldBehavior ? {
      fontSize: size + "px"
    } : {
      height: size
    };
    var logo = isOldBehavior ? this.renderLogoOld() : this.renderLogo();
    var dropdownClassName = cn((_b = {}, _b[jsStyles.dropdown()] = !isOldBehavior, _b[jsStyles.dropdownOld()] = isOldBehavior, _b[jsStyles.inline()] = isOldBehavior && !withWidget, _b));
    var component = React.createElement(Component, __assign({
      href: href,
      tabIndex: "-1",
      className: componentClassName,
      style: styleComponent
    }, isOldBehavior ? {} : (_c = {}, _c['data-logotype-component'] = '', _c)), logo);
    return React.createElement("div", {
      id: "spwDropdown",
      className: dropdownClassName
    }, React.createElement("span", {
      ref: this.refLogoWrapper,
      className: jsStyles.widgetWrapper()
    }, component, withWidget && React.createElement("span", {
      className: dividerClassName,
      style: dividerStyle
    })), withWidget && React.createElement("button", {
      className: buttonClassName,
      onClick: onArrowClick
    }, React.createElement(ArrowChevronDown, {
      color: "#aaa",
      size: 20
    })));
  };

  Object.defineProperty(Logotype.prototype, "isOldBehavior", {
    get: function get() {
      return !this.props.konturLogo;
    },
    enumerable: true,
    configurable: true
  });
  Logotype.__KONTUR_REACT_UI__ = 'Logotype';
  Logotype.propTypes = {
    color: PropTypes.string,
    href: PropTypes.string,
    suffix: PropTypes.string,
    size: PropTypes.number,
    textColor: PropTypes.string,
    withWidget: PropTypes.bool,
    locale: PropTypes.shape({
      prefix: PropTypes.string,
      suffix: PropTypes.string
    })
  };
  Logotype.defaultProps = {
    color: '#D92932',
    textColor: '#333333',
    component: 'a',
    href: '/',
    konturLogo: null,
    productLogo: null
  };
  Logotype = __decorate([locale('Logotype', LogotypeLocaleHelper)], Logotype);
  return Logotype;
}(React.Component);

export { Logotype };